import styled from 'styled-components';

export const ImageContentBoxContainer = styled.div`
    max-width: 100vw;
    height: ${window.screen.width <= 1000 ? '90vh' : '105vh'}; 
    display: flex;
    justify-content: center;
    // margin: 5% 0 5% 0;
`;

export const ImageContentContainer = styled.div`
    color: white;
    width: 98%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    align-items: center;

    .header-info {
        // text-shadow: black 0px 0px 10px;
        background-color: rgba(0,0,0, .02);
        width: 700px;
        max-width: 90%;
        margin: ${window.screen.width <= 1000 ? '10% 0 0 5%' : '7% 0 0 10%'}; 
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // justify-content: center;

        h3 {
           font-size: ${window.screen.width <= 1000 ? '1.6em' : '3.5em'};
           padding: 0 0 1rem 0;
           margin: 0;
        }
        
        p {
           font-size: ${window.screen.width <= 1000 ? '1rem' : '1.4rem'}; 
           line-height: 2rem;
        }

        .button {
            margin: 0;
        }
    }
`;